import { render, staticRenderFns } from "./OneDistribution.vue?vue&type=template&id=06a24376&"
import script from "./OneDistribution.vue?vue&type=script&lang=js&"
export * from "./OneDistribution.vue?vue&type=script&lang=js&"
import style0 from "./OneDistribution.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports